<ng-container>
  <button nz-button nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'bottomCenter'">{{ languageSelected }}</button>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <ng-container *ngFor="let language of supportedLanguages | keyvalue">
        <li nz-menu-item (click)="setLanguage(language.value.languageCd)">{{language.value.languageCd}}</li>
      </ng-container>
    </ul>
  </nz-dropdown-menu>
  <ng-container class='clickable p-l-r-10' *ngIf="multiTenancyConfig.extractLabelFeature">
    <span (click)="fetchMissingLabel()"><i nz-icon [nzType]='"vertical-align-bottom"' nzTheme="outline"></i></span>
  </ng-container>
</ng-container>
